<template>
    <div  class="setting-item clearFloat">
      <div class="content clearFloat">
        <div class="content-item floatLeft" style="width: 100%">
          <div class="font-arrangement-btn justify-content-center ">
            <span class="btn-active" :style="getTranslate1"></span>
            <el-tooltip
              v-for="(val, index) in verticalAlignList"
              :key="index"
              class="item"
              effect="dark"
              :content="val.label"
              placement="top-end"
              :open-delay="1000"
            >
              <span
                :key="index"
                :class="activeVerticalAlign == val.value ? 'select pd2' : 'pd2'"
                @click="changeVerticalAlign(val, '')"
                ><i :class="val.className"></i
              ></span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import "../common.css"
import publicData from "../mixins/publicData.js"

export default {
  mixins: [publicData],
  name: "textVerticalAlignSetting",
  props: {
    verticalAlign:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      verticalAlignList: [
        {
          label: "顶对齐",
          className: "icon-portal-align-top",
          value: "top"
        },
        {
          label: "垂直居中对齐",
          className: "icon-portal-align-middle",
          value: "center"
        },
        {
          label: "底对齐",
          className: "icon-portal-align-bottom",
          value: "bottom"
        }
      ],
      translate1:0,
      itemWidth:0
    }
  },
  computed: {
    /*竖向居中类型*/
    verticalAlignVal: {
      get(){
        return this.verticalAlign
      },
      set(val){
        this.$emit("update:verticalAlign", val)
        this.$emit("change", { type: "verticalAlign", value: val })
      }
    },
    activeVerticalAlign() {
      let index = this.verticalAlignList.findIndex(item => item.value === this.verticalAlign)

      this.translate1 = this.itemWidth * index
      if(!this.itemWidth && this.$el){
        this.itemWidth = this.$el.getElementsByClassName("item")[0].clientWidth
        this.translate1 = this.itemWidth * index
      }
      return this.verticalAlign
    },
    getTranslate1() {
      return {
        transform: `translateX(${this.translate1}px)`
      }
    }
  },
  mounted() {
    this.$nextTick(()=>{
      this.itemWidth = this.$el.getElementsByClassName("item")[0].clientWidth
    })
  },
  methods: {
    changeVerticalAlign(val) {
      this.verticalAlignVal = val.value
    }
  }
}
</script>

<style scoped>
.ml12 {
  margin-left: 12px;
}
.setting-item-txt {
  color: var(--collapsibleItemContentTextColor);
}
.font-arrangement-btn span:hover::before {
  color: var(--collapsibleItemContentTextColor);
}
.cx_style/deep/ .el-input__inner:hover {
  background: var(--inputNuberHoverThemeBgColor) !important;
}
.el-input__inner:active {
  border: 1px solid var(--themeColor) !important;
}
.font-arrangement-btn span {
  width: calc(100% / 5);
}
.font-arrangement-btn span.btn-active {
  width: calc((100% - 6px) / 5);
}
.font-arrangement-btn.justify-content-center span.btn-active {
  width: calc((100% - 6px) / 3);
}
.font-arrangement-btn.multiple span.select {
  background: var(--leftMenuBgColor);
}
.multiple span:first-child::after {
  display: none;
}
.multiple span:nth-child(2)::after {
  display: block;
}
</style>
